import APIClient from './index';

export const getBrands = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Brands`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandBasicObjects = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Brands/basic_objects`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateBrand = (brand, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`Brands/${brand.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};
export const updateBrandSettings = (settings, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`BrandSettings/${settings.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandRegistrationCodes = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`RegistrationCodes/brands`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const addRegistrationCode = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`RegistrationCodes`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateRegistrationCode = (code, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`RegistrationCodes/${code.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const deleteRegistrationCode = code => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`RegistrationCodes/${code.id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandsWithPendingCommissions = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AffiliateCommissions/pending_commission_brands`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getPendingCommissions = Brand_id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AffiliateCommissions/pending_commissions/${Brand_id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getAffiliateCommissions = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AffiliateCommissions`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getAffiliateInvoices = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AffiliateInvoices`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const sendAffiliateInvoice = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`AffiliateInvoices`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const sendBudgetInvoice = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`BrandBudgetInvoices`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateCommission = (commission, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`AffiliateCommissions/${commission.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandBillingOverview = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`BrandBilling/${brandId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBillingWorklist = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`BrandBilling/worklist`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const lookUpStripeObject = (type, id, Brand_id) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`BrandBilling/stripe_lookup?${new URLSearchParams({ type, id, Brand_id }).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateBrandBilling = (brandId, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`BrandBilling/${brandId}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandOpportunityStrategy = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`BrandBilling/${brandId}/opportunity-strategy`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateBrandOpportunityStrategy = (brandId, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`BrandBilling/${brandId}/opportunity-strategy`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandNotificationRecipients = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminBrandNotificationRecipients/${brandId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err?.data?.error));
  });
};

export const saveBrandNotificationRecipients = (brandId, recipients) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`AdminBrandNotificationRecipients/${brandId}`, { recipients })
      .then(response => resolve(response.data))
      .catch(err => reject(err?.data?.error));
  });
};
